module.exports = __webpack_public_path__ + "img/color1_on.775a66c3.png";